import styled from 'styled-components';

export const Button = styled.button`
    border-radius: 15px;
    background: #DF6B78;
    height: 25px;
    position: absolute;
    margin-left: 13%;
    margin-top: 6%;

    `;

export const Input = styled.input.attrs(props => ({
    type: 'text',
    }))`
    border-radius: 7px;
    border: 1px solid #000;
    background: #FFF;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    height: 20px;
    position: absolute;
    margin-left: 150px;
    margin-top: 20px;
    `;

export const Label = styled.label`
    margin-top: 20px;   
    color: #000000;
    text-align: left;
    left: 1%;
    position: absolute;
    `;

export const Div = styled.div`
    display: table-cell;
    text-align: center;
    vertical-align: middle;
    `;